import { registerArtifactPayload } from '@/features/documentPreview/artifactPayloadStore.js'
import { isUsableHtmlPreview, normalizeGeneratedFileContent } from './generatedFileContent.js'
import { buildProjectOverviewHtml } from './aetherProjectOverviewHtml.js'

function projectHtmlArtifact(project, artifactId, fileName, description, payload) {
  return registerArtifactPayload({
    artifactId,
    artifactKind: 'html',
    fileName,
    displayTitle: fileName,
    description,
    downloadUrl: project.download_url,
    downloadFileName: `${project.project_id}.zip`,
    payload,
  })
}

export function buildHtmlArtifactFromProject(project, files = []) {
  if (!project) return null
  if (project.runtime_url) {
    return projectHtmlArtifact(
      project, `backend-project-runtime-${project.project_id}`, 'Live project preview', 'Running app preview',
      { url: project.runtime_url },
    )
  }
  const preview = project.preview
  if (preview?.html && isUsableHtmlPreview(preview.html)) {
    return projectHtmlArtifact(
      project, `backend-project-${project.project_id}`, preview.path, 'Live app preview',
      { html: normalizeGeneratedFileContent(preview.html) },
    )
  }
  if (project.preview_url) {
    return projectHtmlArtifact(
      project, `backend-project-preview-${project.project_id}`, preview?.path || 'Project preview',
      'Generated app preview',
      { url: project.preview_url },
    )
  }
  const overviewFiles = files.length ? files : project.files || []
  const hasProjectFiles = overviewFiles.length > 0 || Number(project.files_count) > 0
  if (!project.download_url || !hasProjectFiles) return null
  return projectHtmlArtifact(
    project, `backend-project-overview-${project.project_id}`, 'Project overview', 'Generated project contents',
    { html: buildProjectOverviewHtml(project, overviewFiles) },
  )
}
